import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

export default function TournamentColumnBox(props) {
  const { value, setValue, placeholder, isModify } = props;
 
  const [width, setWidth] = useState(92);

  const SpanRef = useRef();

  // 인풋 크기 정리 //
  useEffect(() => {
    let width = SpanRef.current?.offsetWidth;

    if (width > 92) setWidth(SpanRef.current.offsetWidth + 4);
    else setWidth(92);
  }, [value])

  // Input 데이터 변경시 //
  function onChange(e) {
    if (!isModify) return;
    setValue(e.target.value);
  }

  return (
    <ColumnBox 
      padding={isModify ? '0px 8px' : '2px 10px'}
      border={isModify && '2px dashed #909090'}
      backgroundColor={isModify ? '#444447' : '#6DD49E'}
      disabled={!isModify}
      hover={isModify ? 'text' : 'default'}>
        <HiddenSpan ref={SpanRef}>{value || placeholder}</HiddenSpan>
        <Input 
          value={value}
          onChange={onChange}
          type='text'
          width={width}
          disabled={!isModify}
          backgroundColor={isModify ? '#444447' : '#6DD49E'}
          hover={isModify ? 'text' : 'default'}/>
    </ColumnBox>
  );
}

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: ${props => props.padding};

  min-width: 92px;
  height: 36px;

  border-radius: 8px;
  border: ${props => props.border};
  background-color: ${props => props.backgroundColor};

  :hover {
    cursor: ${props => props.hover};
  }

  // transition: all 0.3s ease-in-out;
`;

const HiddenSpan = styled.span`
  position: absolute;

  visibility: hidden;
  white-space: pre;

  font-family: NotoSansKR-Bold;
  font-size: 14px;
  line-height: 18px;

  padding: 0;
  margin: 0;
`;

const Input = styled.input`
	font-family: NotoSansKR-Bold;
	font-size: 14px;
	line-height: 18px;

  //width: 100%;
  width: ${props => props.width}px;
  max-width: 800px;
	height: 18px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
  text-align: center;
  color: #FFFFFF;

  border: none;
  background-color: ${props => props.backgroundColor};

  :hover {
    cursor: ${props => props.hover};
  }
  
  // transition: all 0.3s ease-in-out;
`;